import DateHelpers from 'helpers/Date';
import Repository from 'helpers/Repository';
import { RootState } from 'store';

/**
 * Formats a pre-formatted datetime string (DD.MM.YYYY HH:mm:ss) into
 * a localized "DD MMM HH:mm" string (e.g. "02 апр 13:11") using the
 * current interface language from the Redux store.
 */
export const formatLocalizedDate = (raw: string): string => {
  if (!raw) {
    return '—';
  }
  try {
    const locale =
      (Repository.get('store').getState() as RootState).localization
        .interfaceLang ?? 'en';
    const date = DateHelpers.createDate(
      raw.replace('\n', ' '),
      'datetime'
    ).toDate();
    const parts = new Intl.DateTimeFormat(locale, {
      day: '2-digit',
      month: 'short',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    }).formatToParts(date);
    const get = (type: string) =>
      parts.find((p) => p.type === type)?.value ?? '';
    const month = get('month').replace('.', '');
    return `${get('day')} ${month} ${get('hour')}:${get('minute')}`;
  } catch (err) {
    return raw;
  }
};
